<template>
    <q-card
        class="me"
        draggable="true"
        @dragstart.native="ondragstart"
        :style="style"
        v-if="localModel || src">

        <q-card-main>
            <div v-if="! showRealVideo">
                <a href="#"
                   @click.prevent="showRealVideo = true"
                >Kliknij by pokazać podgląd wideo</a>
            </div>

            <video controls style="max-width: 200px; max-height: 200px" v-else>
                <source :src="prefixedSrc">
                Your browser does not support the wideo element.
            </video>

            <div class="name" v-if="localModel">{{localModel.name}}</div>
        </q-card-main>

        <q-card-actions v-if="deletable" align="end">
            <q-btn
                icon="delete"
                flat
                round
                v-if="deletable"
                @click="remove"
            />
        </q-card-actions>
    </q-card>
</template>

<script>
    import QVideo from 'quasar-framework/src/components/video/QVideo'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCard from 'quasar-framework/src/components/card/QCard'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'

    export default {
        name: 'VideoViewer',
        components: {QBtn, QCard, QCardMain, QIcon, QVideo},
        props: ['model', 'draggable', 'src', 'inline', 'deletable', 'width', 'height'],
        methods: {
            ondragstart (e) {
                e.dataTransfer.effectAllowed = 'copy'
                e.dataTransfer.setData('text', JSON.stringify(this.localModel))
            },
                fetchDetailsIfNecessary() {
            },
            remove () {
                this.$store.dispatch('remove', {
                    what: 'file',
                    id: this.localModel.id
                })
            }

        },
        watch: {
            model(current) {
                this.localModel = current;

                this.showRealVideo = false;

                if (current) {
                    this.fetchDetailsIfNecessary();
                }
            }
        },
        mounted() {
            this.localModel = this.model;

            if (this.localModel) {
                this.fetchDetailsIfNecessary();
            }
        },
        data () {
            return {
                localModel: {},
                showRealVideo: false
            }
        },
        computed: {
            mediaType () {
                if (this.localModel) {
                    return this.localModel.mediaType
                } else {
                    if (this.src.endsWith('.mp4')) {
                        return 'video/mp4'
                    } else if (this.src.endsWith('.mpg')) {
                        return 'video/mpeg'
                    } else if (this.src.endsWith('.mov')) {
                        return 'video/mp4"'
                    }
                }
            },
            style () {
                let s = ''
                if (this.inline) {
                    s += 'display: inline'
                }

                if (this.width) {
                    s += `${this.width}px; height: ${this.height}px`
                }

                return s
            },
            prefixedSrc () {
                const src = this.src || this.localModel.urlPath
                return this.$store.state.MEDIA_PREFIX + src
            }
        },

    }
</script>

<style scoped lang="scss">
    .me {
        position: relative;

        video {
            width: 100%;
        }

        .name {
            overflow: hidden;
            -ms-text-overflow: ellipsis;
            text-overflow: ellipsis;
        }
    }
</style>